module.exports = __webpack_public_path__ + "static/media/logo.b46e18ff.jpg";